export const getMediaImage = async ({ name, url }) => {
  return await fetch(url, {
    mode: 'cors'
  })
    .then(res => res.blob())
    .then(res => new File([res], name, {
      type: res.type
    }))
}
